export default [
  {
    name: 'sideBar.dashboard',
    icon: 'nc-icon nc-layout-11',
    path: '/dashboard'
  },
  {
    name: 'sideBar.myFleet',
    icon: 'fa fa-car',
    path: '/fleet'
  },
  {
    name: 'sideBar.vehicleRequest',
    icon: 'nc-icon nc-bullet-list-67',
    path: '/requests'
  },
  {
    name: 'sideBar.contacts',
    icon: 'nc-icon nc-circle-10',
    path: '/contacts'
  },

  {
    name: 'sideBar.chargerReport',
    icon: 'fa fa-bolt',
    path: '/charger-report'
  }
]